import { getAnonymousId, getSessionId } from '@/lib/attribution/storage'
import { ATTRIBUTION_ENABLED } from '@/lib/config'

function isAbsoluteUrl(value: string): boolean {
  return /^[a-z][a-z0-9+.-]*:/i.test(value)
}

export function withDownloadAttributionParams(url: string): string {
  if (typeof window === 'undefined') return url
  if (!ATTRIBUTION_ENABLED) return url

  try {
    const parsed = new URL(url, window.location.origin)

    const anonymousId = getAnonymousId()
    const sessionId = getSessionId()

    if (anonymousId && !parsed.searchParams.has('anonymous_id')) {
      parsed.searchParams.set('anonymous_id', anonymousId)
    }

    if (sessionId && !parsed.searchParams.has('session_id')) {
      parsed.searchParams.set('session_id', sessionId)
    }

    if (isAbsoluteUrl(url)) {
      return parsed.toString()
    }

    return `${parsed.pathname}${parsed.search}${parsed.hash}`
  } catch {
    return url
  }
}
